<template>
  <div class="video-player" :style="mainStyle">
    <video v-if="videoType === 'webrtc'" ref="videoRef" class="h-video" autoplay muted="true"></video>
    <div v-else class="h-video" ref="playerRef"></div>
    <div v-if="title" class="video-name">{{ title }}</div>
  </div>
</template>

<script>
import XgPlayer from 'xgplayer';
import 'xgplayer/dist/index.min.css';
import FlvPlugin from 'xgplayer-flv';
import { Events as XgEvents } from 'xgplayer'
export default {
  name: 'VideoPlayer',
  components: {},
  props: {
    width: {
      type: [String, Number],
      default: null
    },
    height: {
      type: [String, Number],
      default: null
    },
    url: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    data: {//额外的数据
      type: Object,
      default: () => { }
    }
  },

  data() {
    return {
      loading: false,
      isMobile: window.innerWidth <= 768, // 初始判断移动端
      videoType: 'mp4'
    };
  },
  computed: {
    mainStyle() {
      const defaultWidth = 600
      let width = this.width;
      let height = this.height;
      if (!width) {
        // 没传就用默认宽度
        width = this.isMobile ? '100%' : `${defaultWidth}px`;
      } else if (typeof this.width === 'number') {
        width = this.width + 'px'
      }
      if (!height) {
        // 没传就用默认高度
        height = this.isMobile ? '200px' : `${defaultWidth * 9 / 16}px`;
      } else if (typeof this.height === 'number') {
        height = this.height + 'px'
      }
      return {
        width: width,
        height: height
      }
    }
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    /**
    * 初始化SRS RTC播放器
    *
    * 初始化SRS RTC播放器，并将视频流绑定到页面上指定的视频元素。
    * 如果指定的视频元素不存在，则直接返回。
    */
    initSrsRtcPlay() {
      if (!this.$refs.videoRef) return;
      let srsSdk = new SrsRtcPlayerAsync();
      this.$refs.video.srcObject = srsSdk.stream;
      srsSdk.play(url)
        .then((session) => { })
        .catch((reason) => {
          srsSdk.close();
          this.loading = true;
          console.error(reason);
        });
      this.sdk = sdk;
    },
    initXgPlayer() {
      const self = this
      let plugins = [FlvPlugin];
      if (this.player) {
        this.player.destroy();

      }
      let player = new XgPlayer({
        el: this.$refs.playerRef,
        url: this.url,
        plugins: plugins,
        isLive: true,
        autoplay: true,
        muted: true,
        width: this.mainStyle.width,
        height: this.mainStyle.height,

      })
      this.player = player;
      player.getPlugin('error').useHooks('showError', (...args) => {
        // console.error(args);
      })
      player.on(XgEvents.PLAY, () => {
        this.loading = false;
      })
      player.on(XgEvents.ERROR, (err) => {

        if (err.errorType == 'network') {
          self.initXgPlayer()
        }
      })
      player.on(XgEvents.AUTOPLAY_PREVENTED, () => {
        console.log("自动播放失败，尝试手动播放")
        player.play()
      })
      player.on(XgEvents.WAITING, () => {
        console.log("播放器等待中")
        player.play()
      })
    },
    init() {

      const url = this.url;
      if (url) {
        if (url.indexOf(".flv") > -1) {
          this.videoType = "flv"
        } else if (url.indexOf(".m3u8") > -1) {
          this.videoType = "hls"
        } else if (url.indexOf(".mp4") > -1) {
          this.videoType = "mp4"
        } else if (url.indexOf("webrtc") > -1) {
          this.videoType = "webrtc"
        }
        switch (this.videoType) {
          case "flv":
            this.initXgPlayer()
            break;
          case "hls":
            this.initXgPlayer()
            break;
          case "mp4":
            this.initXgPlayer()
            break;
          case "webrtc":
            this.initSrsRtcPlay()
            break;
        }
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.init()
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>


<style lang="scss" scoped>
.video-player {
  position: relative;
  display: inline-block;
  background-color: #000000;

  .h-video {
    width: 100%;
    height: 100%;
    background: #000000;
    position: relative
  }

  .video-name {
    position: absolute;
    top: 0px;
    left: 0px;
    color: #ffffff;
    z-index: 100;
    padding: 6px;
    font-size: 12px;
    user-select: none;
  }

}
</style>